// nGinx knows where to send reqs.
const BACKEND_PATH = '/backend';

const getBackendPath = () => {
    return getProtocol() === 'https:' ? BACKEND_PATH : '';
}

const getHostName = () => {
    return window.location.hostname;
}

const getProtocol = () => {
    return window.location.protocol;
};

const getHTTPSPort = () => {
    return window.location.port === ''? 443 : window.location.port;
}

const getPort = () => {
    return getProtocol() === 'https:'? getHTTPSPort() : process.env.BACKEND_PORT || 8000;
}

export const config = {
  "project_name": "Lena",
  "project_version": "0.0.1",
  "project_description": "A platform for the secure management and control of the drug lenalidomide by healthcare professionals.",
  "server_url_base": `${getProtocol()}//${getHostName()}:${getPort()}${getBackendPath()}`,
  "enableSSE": false,
};

export const getBaseURL = () => {
    return config.server_url_base;
};
